import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { Link, Spinner } from "@fluentui/react-components";
import { Open16Regular } from "@fluentui/react-icons";
import { useMessage } from "../../blocks/message/MessageContext";
import { MODULAR_HTML } from "../../utils/Constants";
import Ows from "../../utils/OwsHandler";

const VacancyLink = ({ vacancyUid }) => {
  const { showMessage } = useMessage();
  const [settings, setSettings] = useState({
    domain: process.env.OWS_DEFAULT_DOMAIN,
    domainPrefix: process.env.OWS_DEFAULT_DOMAIN_PREFIX,
  });
  const defaultLanguage = useSelector((state: RootState) => state.user?.defaultContentLanguage) || "en";

  useEffect(() => {
    (async () => {
      try {
        const { response } = await Ows.handleRequest("Otys.Services.SettingsService.get", [
          { phoenix_fo: ["domain_for_client", "phoenix_domain_prefix"] },
          null,
        ]);
        
        setSettings({
          domain: response.phoenix_fo.domain_for_client || process.env.OWS_DEFAULT_DOMAIN,
          domainPrefix: response.phoenix_fo.phoenix_domain_prefix || process.env.OWS_DEFAULT_DOMAIN_PREFIX,
        });
      } catch (error) {
        showMessage("error", "Failed to fetch vacancy link");
        console.error("Error fetching settings:", error);
      }
    })();
  }, []);

  return settings.domain && settings.domainPrefix ? (
    <Link 
      as="a" 
      href={`https://${settings.domainPrefix}.${settings.domain}.com/${defaultLanguage}/${MODULAR_HTML}/vacancies/${vacancyUid}`} 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <Open16Regular />
    </Link>
  ) : (
    <Spinner size="extra-tiny" />
  );
};

export default VacancyLink;